/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_spec_card__blablacar__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Bilden Sie Fahrgemeinschaften`
};

const en_route_spec_card__blablacar__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Carpool`
};

const es_route_spec_card__blablacar__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Compartir coche`
};

const fr_route_spec_card__blablacar__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Covoiturez`
};

const it_route_spec_card__blablacar__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Carpooling`
};

const nl_route_spec_card__blablacar__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Carpool`
};

const pt_route_spec_card__blablacar__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Boleia`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__cta = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_spec_card__blablacar__cta(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_spec_card__blablacar__cta", locale)
	if (locale === "de") return de_route_spec_card__blablacar__cta(inputs)
	if (locale === "en") return en_route_spec_card__blablacar__cta(inputs)
	if (locale === "es") return es_route_spec_card__blablacar__cta(inputs)
	if (locale === "fr") return fr_route_spec_card__blablacar__cta(inputs)
	if (locale === "it") return it_route_spec_card__blablacar__cta(inputs)
	if (locale === "nl") return nl_route_spec_card__blablacar__cta(inputs)
	return pt_route_spec_card__blablacar__cta(inputs)
};